import React from "react";
import { FaFolderOpen, FaGithub } from "react-icons/fa";
import "./Work.css";

const projects = [
  {
    title: "Game Therapy",
    description: `
      Developed an adaptive game platform to assist individuals with cognitive and emotional challenges.
      Interactive games include a dyslexia-friendly game using Arduino-based hand gestures and a maze game to enhance motor skills.
      Integrated an AI chatbot therapist using Llama and other LLMs for personalized support, along with a guardian dashboard featuring progress charts.
      Designed a secure authentication system with JWT tokens.
    `,
    techStack: [
      "MERN Stack",
      "Twilio",
      "Google APIs",
      "TensorFlow",
      "Hugging Face",
      "JWT",
      "Charts.js",
    ],
    githubLink: "https://github.com/vikasp07/Game-Theraphy",
  },
  {
    title: "CampusRick",
    description: `
      Developed a ride-sharing application to simplify commuting and reduce waiting times for college students.
      Implemented a real-time booking system with triple-sharing functionality, automated fare calculation, and live vehicle tracking using the Google Maps API.
    `,
    techStack: [
      "Node js",
      "Flutter",
      "FlutterFlow",
      "SupaBase",
      "Google Maps API",
    ],
    githubLink: "https://github.com/vikasp07/CampusRick",
  },
  {
    title: "WanderLust",
    description: `
      Built a full-stack travel platform enabling users to explore and share their favorite destinations.
      Ensured secure user authentication with Passport.js, used Multer for image uploads, and integrated Cloudinary for image storage.
      Users can create, edit, and delete listings, as well as review destinations.
    `,
    techStack: [
      "MongoDB",
      "ExpressJS",
      "NodeJS",
      "Cloudinary",
      "Passport.js",
      "Bootstrap",
    ],
    githubLink: "https://github.com/vikasp07/Wander_lust",
  },
];

const Work = () => {
  return (
    <section className="work-section" id="work">
      <h2 className="work-title">Some Things I&apos;ve Built</h2>
      <div className="work-grid">
        {projects.map((project, idx) => (
          <div className="project-card" key={idx}>
            {/* Card Header */}
            <div className="card-header">
              <FaFolderOpen className="folder-icon" />
              <a
                href={project.githubLink}
                target="_blank"
                rel="noopener noreferrer"
                className="github-link"
              >
                <FaGithub />
              </a>
            </div>
            {/* Card Body */}
            <h3 className="project-title">{project.title}</h3>
            <p className="project-description">{project.description}</p>
            {/* Tech Stack List */}
            <ul className="tech-stack">
              {project.techStack.map((tech, i) => (
                <li key={i}>{tech}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Work;
